module.exports = __webpack_public_path__ + "img/dragon-quest-xi.cbe6055e.png";